<div class="container">
  <!--Product List Title-->
  <div class="order-card-titles-layout">
    <span class="left-title-layout">
      {{ 'ACTIVATION.CONFIRMATION_PAGE.ACTIVATION_PRICE.PRODUCT_SERVICE_NAME' | translate }}
    </span>
    <span *ngIf="!hidePricing">
      {{ 'COMMON.PRICING.WHOLESALE_COST' | translate }}
    </span>
  </div>

  <!--Product List-->
  <mat-list class="product-list" *ngIf="summaries && summaries.length; else displayStencil">
    <ng-container *ngFor="let purchase of summaries">
      <mat-list-item>
        <div class="list-item">
          <div class="left-section">
            <div class="left-section-block">
              <div class="icon-and-name">
                <div class="icon-container">
                  <va-icon [diameter]="32" [iconUrl]="purchase.icon" [iconName]="purchase.name"></va-icon>
                </div>
                <div class="purchase-name-row">
                  {{ purchase.name }}
                  <span *ngIf="purchase.editionName">&nbsp;| {{ purchase.editionName }}</span>
                  <span *ngIf="purchase.quantity > 1">&nbsp;({{ purchase.quantity }})</span>
                </div>
              </div>
            </div>
            <div *ngIf="purchase.activationMessage?.length > 0" class="activation-message">
              <mat-icon class="message-icon">info_outline</mat-icon>
              <div class="message-text">{{ purchase.activationMessage }}</div>
            </div>
          </div>

          <div class="right-section" *ngIf="!hidePricing && purchase.appPrices">
            <a
              (click)="openChangePriceDialog(purchase)"
              *ngIf="purchase.effectiveAppPrice.billingConfiguration.usesVariablePricing"
            >
              {{ 'COMMON.ACTION_LABELS.EDIT' | translate }}
            </a>
            <div class="price-display">
              <billing-ui-simple-price-display
                [price]="purchase.generalPriceInfo.price"
                [frequency]="purchase.generalPriceInfo.frequency"
                [currencyCode]="purchase.partnerCurrency"
                [setupFee]="purchase.generalPriceInfo.setupFee"
                [commitment]="purchase.generalPriceInfo.commitment"
                [stairSteps]="purchase.generalPriceInfo.stairSteps"
                [discounts]="purchase.generalPriceInfo.discounts"
                [fees]="purchase.generalPriceInfo.fees"
                [contactSales]="purchase.generalPriceInfo.contactSales"
              ></billing-ui-simple-price-display>
            </div>
          </div>
        </div>
      </mat-list-item>
    </ng-container>
  </mat-list>
</div>

<!--Totals Section-->
<div *ngIf="!hidePricing">
  <div class="totals-card-layout" *ngIf="summaries; else displayStencil">
    <div class="total-header">
      {{ 'COMMON.PRICING.TOTAL' | translate }}
      <span *ngIf="!productsAreInstantBilled">
        ({{ 'ACTIVATION.CONFIRMATION_PAGE.ACTIVATION_PRICE.FIRST_CHARGE_AT_MONTHS_END' | translate }})
      </span>
    </div>
    <div class="total">
      <div class="row">
        <div class="col col-xs-12 total--charge">
          <strong *ngIf="!contactSalesForOrder">
            <billing-ui-simple-price-display
              [price]="total"
              [currencyCode]="currency"
            ></billing-ui-simple-price-display>
          </strong>
          <strong *ngIf="contactSalesForOrder">
            <billing-ui-simple-price-display [contactSales]="true"></billing-ui-simple-price-display>
          </strong>
        </div>
      </div>
      <div class="row" *ngFor="let charge of recurringTotals | keyvalue; let first = first">
        <div class="col col-xs-4 total--recurring-description">
          <span *ngIf="first">
            {{ 'COMMON.PRICING.RECURRING_CHARGES' | translate }}
          </span>
        </div>
        <div class="col col-xs-8 total--recurring-charge">
          <span *ngIf="charge.value.isStartingPrice">
            {{ 'COMMON.PRICING.STARTING_AT' | translate }}
          </span>
          <div class="price-box">
            <billing-ui-simple-price-display
              [price]="charge.value.total"
              [frequency]="charge.value.frequency"
              [currencyCode]="currency"
              [componentTextLength]="'verbose'"
              [topLabel]="charge.value.isStartingPrice ? 'starting-at' : null"
            ></billing-ui-simple-price-display>
          </div>
        </div>
      </div>
      <div class="row" *ngIf="!productsAreInstantBilled">
        <div class="col col-xs-12 total--note">
          *
          {{ 'ACTIVATION.CONFIRMATION_PAGE.ACTIVATION_PRICE.PRICES_ESTIMATED_BASED_ON_VOLUME' | translate }}
        </div>
      </div>
    </div>
  </div>
</div>

<ng-template #displayStencil>
  <div class="stencil-shimmer"></div>
</ng-template>
